<template lang="pug">
    div
        manager-wholesale-discounts(submitText="Actualizar" crudOption="show-edit"
            @clear-form="clearForm"
            @submit-form="submitForm"
            @return-previous-route="returnPreviousRoute"
            @cancel-editing="restartEditing"
            @delete="confirmDelete"
            )
            product-data
</template>

<script>
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import ManagerWholesaleDiscounts from '@/components/WholesaleDiscount/Manager'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils'
import { DELETE_WHOLESALE_DISCOUNT } from '@/components/SnackbarModal/SnackbarActions'

import ProductData from './ProductData'

import ProductsWholesaleDiscountService from '@/services/api/product/ProductsWholesaleDiscountService'
import { mapActions, mapState } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {}
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        ...mapState('WholesaleDiscountModule', {
            arrayDiscounts: 'arrayDiscounts',
            id: 'id',
        }),
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        ...mapActions('WholesaleDiscountModule', {
            resetStateWholesaleDiscount: 'resetState',
            resetArrayDiscounts: 'resetArrayDiscounts',
            setInitialArrayDiscounts: 'setInitialArrayDiscounts',
            restartEditingWholesaleDiscount: 'restartEditing',
            setGlobalPercentageDiscount: 'setGlobalPercentageDiscount',
            setId: 'setId',

        }),

        restartEditing(){
            this.restartEditingWholesaleDiscount()
        },

        confirmDelete(){
            this.resetSnackbarState()
            this.setMessageConfirmSnack(DELETE_WHOLESALE_DISCOUNT)
            let payload = this.fillSnack('warning',
            '¿Desea eliminar esquema de descuentos?',
            'Si actualiza, se borrarán todos los esquemas existentes', false, 0, true, 'Cancelar')
            this.initSnackbar(payload)
            // this.itemDeleteId = event
            // console.log(event)

        },

        clearForm(){
            this.resetArrayDiscounts()
        },

        async submitForm() {
            let snackLoading = this.fillSnack(
                'info',
                'Actualizando esquema',
                'Espere un momento',
                true,
                6000
            )
            this.initSnackbar(snackLoading)
            let response = await ProductsWholesaleDiscountService.updateWholesaleDiscounts(this.arrayDiscounts, this.id)
            if (response.status == 'success') {
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'El esquema de descuentos se ha actualizado exitosamente',
                    false,
                    6000
                )
                this.initSnackbar(snackInfo)
                this.returnPreviousRoute()
            } else {
                //TODO: test response error from backend
                let snackInfo = this.fillSnack(
                    'error',
                    'Error',
                    response,
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
            }
        },

        returnPreviousRoute() {
            this.$router.push({ path: `/products/${this.id}` })
        },

    },
    watch: {
        async responseConfirm(val){
            if(val == DELETE_WHOLESALE_DISCOUNT){
                let response = await ProductsWholesaleDiscountService.deleteWholesaleDiscounts(this.id)
                if(response.status=='success'){
                    this.resetSnackbarState()
                    let payload = this.fillSnack('success','Esquema de descuentos eliminado', '')
                    this.initSnackbar(payload)
                    this.returnPreviousRoute()
                    
                }
                else{
                    this.resetSnackbarState()
                    let payload = this.fillSnack('error','Error', response)
                    this.initSnackbar(payload)
                }
            }
        }
    },
    components: { ManagerWholesaleDiscounts, ProductData },
    mixins: [InputValidations, CurrencyUtils, SnackbarModalUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    beforeMount: async function() {
        let idProduct = this.$route.params.id
        let whDiscounts = await ProductsWholesaleDiscountService.fetchWholesaleDiscountsProduct(idProduct)
        if(whDiscounts === null || whDiscounts.length === 0){ // Wholesale discounts should be created
            this.$router.push({ path: `/products/${idProduct}/wholesale_discounts/create` })
        }else{ // Wholesale discounts should be shown/edited
            this.resetStateWholesaleDiscount()
            this.setGlobalPercentageDiscount(false)
            this.setId(idProduct)
            this.setGlobalPercentageDiscount(false)
            this.setInitialArrayDiscounts(whDiscounts)
        }
        
    },
    mounted: function() {
        this.setTitleTopBar('EDITAR ESQUEMA DESCUENTOS PRODUCTO')
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>